/**
 * Copy for the order-detail share sheet (JSAD-6877), exported so the Jest and Cypress
 * specs assert against these rather than duplicated literals — the same reason
 * `SharedItemConfirmModal` exports its strings.
 */

export const SHARE_SHEET_TITLE = 'Share your creations!';

export const SHARE_SHEET_BODY =
    'Copy a link for any item below and share your customized creations. Anyone who opens the link will instantly add the item to their bag.';

/** The header affordance that opens the sheet. */
export const SHARE_ENTRY_LABEL = 'Share';

/** Shown on a row for ~1.6s after its link is copied (web). */
export const SHARE_SHEET_COPIED_LABEL = 'Copied';

/*
 * Lines that cannot produce a link are HIDDEN, never shown with a disabled button (JSAD-7497).
 * When that leaves the sheet empty, one of these explains why nothing can be shared.
 */

/** Resolved, nothing shareable, every line has left the menu (or is an incomplete combo). */
export const SHARE_SHEET_EMPTY =
    "None of these items are on the menu right now, so they can't be shared.";

/** Resolved, nothing shareable, every line a snack or drink. */
export const SHARE_SHEET_EMPTY_SIDES_ONLY =
    "Snacks and drinks can't be shared, so there's nothing to share here.";

/** A Pick 2 whose combo is listed but some halves are out of stock (JSAD-7506, QA wording). */
export const SHARE_SHEET_EMPTY_PICK_TWO =
    'This Pick-2 cannot be shared because some included items are out of stock.';

/*
 * Resolved, nothing shareable, and the hidden lines have DIFFERENT reasons (e.g. a Pick 2 with an
 * out-of-stock item plus a snack): one line per reason, so each item gets its own explanation.
 */
export const SHARE_SHEET_LINE_SIDES = "Snacks and drinks can't be shared.";
export const SHARE_SHEET_LINE_OFF_MENU = "Some items aren't on the menu right now.";

export const SHARE_SHEET_ERROR = "We couldn't load the menu. Please try again.";

export const SHARE_SHEET_RETRY = 'Try again';

export const SHARE_SHEET_CLOSE_LABEL = 'Close';

/** How long a row stays in its `Copied` state before reverting. */
export const COPIED_RESET_MS = 1600;
